export default function emptyArrayToUndefined<T extends any>(
  array?: T[]
): T[] | undefined {
  return array?.length === 0 ? undefined : array
}
